module.exports = __webpack_public_path__ + "img/product5.a0231a67.png";